var _style, _g, _path, _path2, _path3, _path4, _polygon, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergyDrinks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6393D;}\n\t.st1{fill:#CECECE;}\n\t.st2{fill:#29384F;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.35,157.6H87.69c-3.01,0-5.46-2.44-5.46-5.46V70.09c0-3.01,2.44-5.46,5.46-5.46h36.66 c3.01,0,5.46,2.44,5.46,5.46v82.05C129.8,155.16,127.36,157.6,124.35,157.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M124.44,154.36H87.59c-2.96,0-5.36-2.4-5.36-5.36V70c0-2.96,2.4-5.36,5.36-5.36h36.85 c2.96,0,5.36,2.4,5.36,5.36v79C129.8,151.96,127.4,154.36,124.44,154.36z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.64,49.07h-3.24c-1.63,0-2.94,1.32-2.94,2.94v9.39c0,1.63,1.32,2.94,2.94,2.94h3.24 c1.63,0,2.94-1.32,2.94-2.94v-9.39C110.58,50.39,109.26,49.07,107.64,49.07z M109.46,58.92c0,0.89-0.73,1.62-1.62,1.62h-3.65 c-0.89,0-1.62-0.73-1.62-1.62v0c0-0.89,0.73-1.62,1.62-1.62h3.65C108.73,57.31,109.46,58.03,109.46,58.92L109.46,58.92z  M106.02,55.48c-2.04,0-3.69-1.18-3.69-2.63c0-1.45,1.65-2.63,3.69-2.63s3.69,1.18,3.69,2.63C109.71,54.3,108.06,55.48,106.02,55.48 z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.46,64.65H86.58c-1.08,0-1.96-0.88-1.96-1.96v0c0-1.08,0.88-1.96,1.96-1.96h38.88 c1.08,0,1.96,0.88,1.96,1.96v0C127.42,63.77,126.54,64.65,125.46,64.65z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "115.66,86.25 103.05,86.25 92.08,108.64 104.09,108.64 96.08,133.7 119.96,99.74 108.98,99.74 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M76.75,119.26c0,0-0.19,0.13-0.45,0.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyDrinks);
export default __webpack_public_path__ + "static/media/Energy_drinks.952034cb1f170964c9220c69d4f0917f.svg";
export { ForwardRef as ReactComponent };